let language = {
    PHOTO_LIB_EDITER_TITLE:"Card Rarity Level",
    PHOTO_LIB_EDITER_DES:"Create up to 10 rarity levels for your collection.", 
    PHOTO_LIB_EDITER_ADD_RARITY:"ADD CARD RARITY", 
    PHOTO_LIB_EDITER_UPDATE_STORE_PRODUCT_ISSUE:"Saving Product Failed",
    PHOTO_LIB_EDITER_UPDATE_STORE_PRODUCT_ISSUE_CONTENT:"An issue occurred while update store product. Please try again later. If the problem persists, feel free to contact our support team at {{supportmail}}."
}
export { language }